import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { v1URL } from '../../../shared/constants/urls.constants';
import { CommonService } from '../../../shared/services/common.service';

@Injectable({
  providedIn: 'root',
})
export class FoodGuideService {

  constructor(private commonService: CommonService) {
  }

  fetchFoodGuideList(payload: any): Observable<any> {
    const urlConfig = v1URL.foodGuide.list;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchFoodGuideItem(id: number): Observable<any> {
    const urlConfig = v1URL.foodGuide.getById;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(id));
  }

  createFoodGuideItem(payload: any): Observable<any> {
    const urlConfig = v1URL.foodGuide.create;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  updateFoodGuideItem(id: number, payload: any): Observable<any> {
    const urlConfig = v1URL.foodGuide.update;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(id), payload);
  }

  retireFoodGuideItem(id: number): Observable<any> {
    const urlConfig = v1URL.foodGuide.retire;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(id));
  }

  unretireFoodGuideItem(id: number): Observable<any> {
    const urlConfig = v1URL.foodGuide.unretire;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(id));
  }

  fetchFoodGuideHistory(id: number, payload?: any): Observable<any> {
    const urlConfig = v1URL.foodGuide.history;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(id, payload));
  }

  fetchFoodCategories(): Observable<any> {
    const urlConfig = v1URL.filters.foodCategory;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }
}
